import { useMutation } from '@tanstack/react-query';

import { reachoutClient } from 'clients/ReachoutClient/ReachoutClient';

export const useProcessCampaignAIMutation = () => {
  return useMutation(
    async (campaignId: string) => {
      try {
        const { data } = await reachoutClient.processCampaignAI(campaignId);

        if (data.generated_vacancy_text) {
          return data.generated_vacancy_text;
        }
      } catch (error) {
        console.error('Error processing vacancy:', error);

        return null;
      }

      return null;
    },
    { retry: 0 },
  );
};
